import React from "react";

interface IEmptyStateProps {
  title: string;
  message?: string;
  icon?: string;
  action?: React.ReactNode;
}

/** What a list shows when it has nothing — instead of a blank table body. */
export const EmptyState: React.FC<IEmptyStateProps> = ({
  title,
  message,
  icon = "bi-inbox",
  action,
}) => (
  <div className="text-center text-muted py-5">
    <i className={`bi ${icon}`} style={{ fontSize: "2rem", opacity: 0.5 }} />
    <div className="fw-semibold mt-2">{title}</div>
    {message && <div className="small mt-1">{message}</div>}
    {action && <div className="mt-3">{action}</div>}
  </div>
);
